export default __webpack_public_path__ + "32b9fc9ec13f3b528cb9e6bbebf9ec62.svg";